import { render, staticRenderFns } from "./TermSignature.vue?vue&type=template&id=4782b5a4&scoped=true"
import script from "./TermSignature.vue?vue&type=script&lang=js"
export * from "./TermSignature.vue?vue&type=script&lang=js"
import style0 from "./TermSignature.vue?vue&type=style&index=0&id=4782b5a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4782b5a4",
  null
  
)

export default component.exports